<template>
  <element>
    <div v-if="active" class="overlay grey"></div>
    <v-menu
      :close-on-content-click="false"
      v-model="active"
      left
      bottom
      offset-y
      nudge-bottom
      rounded="false"
      transition="slide-x-reverse-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          @click="onClick"
        >
          <v-app-bar-nav-icon></v-app-bar-nav-icon>
        </v-btn>
      </template>
      <v-container class="sidebar-container">
        <section class="sidebar-header">
          <div class="d-flex flex-column">
            <div class="avatar-container d-flex align-items-center justify-content-center">
              <img v-if="avatar != null" :src="avatar" alt="Avatar" />
              <v-icon v-else size=64 color="#ffffff">mdi-account</v-icon>
            </div>
            <span class="welcome">{{ $t('sideMenu.welcome') }}</span>
            <span class="name">{{ firstName }}</span>
          </div>
        </section>
        <section class="lang-options">
          <img :class="{ 'selected': icelandic }" src="../../assets/iceland.png" alt="Iceland flag" @click="changeLanguage(true)" />
          <img :class="{ 'selected': !icelandic }" src="../../assets/uk.png" alt="UK flag" @click="changeLanguage(false)" />
        </section>
        <main>
          <ul>
            <li 
              v-for="(item, index) in items"
              :key="index">
              <router-link
                :to="item.path"
                class="text-decoration-none"
                @click.native="onItemClick">
                <SideBarMenuItem :icon="item.icon" :label="item.label" />
              </router-link>
            </li>
            <li>
              <SideBarMenuItem icon="mdi-exit-run" :label="$t('sideMenu.logout')" @click.native="onLogout"/>
            </li>
          </ul>
        </main>
      </v-container>
    </v-menu>
  </element>
</template>

<script>
import SideBarMenuItem from "./SideBarMenuItem.vue"
import { DOCUMENT_TYPE_USER_AVATAR } from "@/constants"

export default {
  name: "SideBar",
  props: {},
  components: {
    SideBarMenuItem
  },
  data() {
    return {
      active: false,
      firstName: '',
      lastName: '',
      avatar: null,
    }
  },
  computed: {
    items: function() {
      return [
        {
          "icon": "mdi-chart-donut",
          "label": this.$t('sideMenu.dashboard'),
          "path": "/dashboard"
        },
	/*
        {
          "icon": "mdi-chart-sankey-variant",
          "label": this.$t('sideMenu.operations'),
          "path": "/dashboard" // td 202008231813 updated this for 2020.1.0b1
        },
	*/
        {
          "icon": "mdi-car",
          "label": this.$t('sideMenu.vehicles'),
          "path": "/car"
        },
        {
          "icon": "mdi-car-cog",
          "label": this.$t('sideMenu.parts'),
          "path": "/search" // td 202008231813 updated this for 2020.1.0b1
        },
        {
          "icon": "mdi-comment-text-outline",
          "label": this.$t('sideMenu.feedbacks'),
          "path": "/feedback"
        },
      ]
    },
    icelandic: function() {
      return this.$i18n.locale == 'is'
    },
    isProcessFlow: function () {
      return this.$store.getters.getCurrentTDK !== null
    },
  },
  methods: {
    onClick() {
      this.active = !this.active
    },
    onItemClick() {
      const currentTDK = this.$store.getters.getCurrentTDK
      if (currentTDK !== null && this.isProcessFlow) {
        this.$store.commit('setCurrentTaskDefinitionKey', null)
        this.$store.commit('setCurrentProcess', null)
      }
    },
    changeLanguage(is_icelandic) {
      this.$i18n.locale = is_icelandic ? 'is' : 'en'
      localStorage.setItem('lang', this.$i18n.locale)
    },
    onLogout() {
      this.$store.dispatch('logout')
      .then(response => {
        this.$router.push({ name: 'login' })
        console.log("Logged out!", response)
      })
      .catch(error => {
        console.log("Failed to logout", error)
      })
    }
  },
  created() {
    const userId = localStorage.getItem('userId')

    if (userId !== null) {
      this.axios.get(`/Users/get/${userId}`, {}, { withCredentials: true })
      .then(response => {
        if ('first_name' in response.data.data) {
          this.firstName = response.data.data.first_name
        } else {
          console.log('There is no field called <first_name>')
        }
      })
      .catch(error => {
        console.log('Failed retrieving user information', error)
      })

      this.axios.get(`/Documents/get?document_type_id=${DOCUMENT_TYPE_USER_AVATAR}&data_id=${userId}`, {}, { withCredentials: true })
      .then(response => {
        this.avatar = response.data.data[0].data_doc_raw
      })
      .catch(error => {
        console.log('Failed retrieving user profile picture!', error)
      })
    }
  }
}
</script>

<style scoped>
.v-menu__content{
  border-radius: 0;
  position: fixed;
  top: 3rem!important;
  background-color: white;
}

@media only screen and (max-device-width: 600px) {
  .overlay {
    display: none;
  }
}

.grey {
  background:rgba(216, 216, 216, 0.3)
}

.sidebar-container {
  width: 17rem;
  height: calc(100vh - 3rem);
  padding: 0;
  background-color: white;
  z-index: 4;
}

.sidebar-header {
  height: 18.875rem;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.975), rgba(255, 255, 255, 1)), url('../../assets/sidebar-background.jpg');
  background-repeat: no-repeat, no-repeat;
  background-position: top;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
}

.avatar-container {
  width: 4.75rem;
  height: 4.75rem;
  border-radius: 0.25rem;
  background-color:rgba(180, 180, 180, 0.75)
}

.avatar-container img {
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
}

.sidebar-header span {
  font-size: 0.9375rem;
}

.welcome {
  color: #2E384D;
}

.name {
  color: #BFC5D2; 
}

.lang-options {
  height: 4.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.5625rem;
  padding-bottom: 1.5625rem;
}

.lang-options img {
  width: 3.75rem;
  height: 2.75rem;
  padding: 0.3rem;
  margin: 0 1.5rem;
  cursor: pointer;
}

.lang-options img.selected {
  outline: 0.2rem solid #d9753b;
}

</style>
